const trustPoints = [
  {
    icon: "ri-focus-3-line",
    title: "多渠道交叉核对",
    desc: "每条猛料都对齐多方渠道与时间线后再放上曝光台，不拍脑袋下定论。",
  },
  {
    icon: "ri-question-answer-line",
    title: "传闻待证会标注",
    desc: "尚无定论的爆料一律以「曝料 / 待回应」呈现，区分事实与猜测。",
  },
  {
    icon: "ri-shield-check-line",
    title: "内容可申诉更正",
    desc: "如涉及事实出入或误解，可通过页脚渠道说明，核实后据实更正。",
  },
];

export default function WatchCta() {
  return (
    <section id="guan" className="bg-background-100/70 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
          {/* 信任侧 */}
          <div>
            <p className="inline-flex items-center gap-2 mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
              <span className="h-px w-6 bg-primary-500 inline-block" />
              为什么可以放心追更
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
              每日黑料只做有依据的独家曝光
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xl">
              我们深知「黑料曝光台」的分量：爆料不能变成谣言。所以每一条都经过核实、标注与复盘，让你吃得放心，追得明白。
            </p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {trustPoints.map((t, i) => (
                <div
                  key={i}
                  className={`rounded-lg p-4 ${i === 0 ? "bg-accent-500 text-background-50" : "border border-background-200 bg-background-50"}`}
                >
                  <i
                    className={`${t.icon} w-6 h-6 flex items-center justify-center mb-2 ${
                      i === 0 ? "text-background-50" : "text-primary-600"
                    }`}
                  />
                  <p className={`text-sm font-bold mb-1 ${i === 0 ? "text-background-50" : "text-foreground-950"}`}>
                    {t.title}
                  </p>
                  <p className={`text-xs leading-relaxed ${i === 0 ? "text-background-50/90" : "text-foreground-600"}`}>
                    {t.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* 追更 CTA */}
          <div className="rounded-lg bg-foreground-950 text-background-50 p-6 md:p-8 relative overflow-hidden">
            <div className="pointer-events-none absolute -right-8 -top-8 w-40 h-40 rounded-full bg-primary-600/30 blur-2xl" />
            <div className="pointer-events-none absolute -bottom-10 -left-6 w-44 h-44 rounded-full bg-accent-600/20 blur-2xl" />
            <div className="relative">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1.5 text-xs font-semibold text-accent-300">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-blink" />
                抢在别人之前吃瓜
              </span>
              <h3 className="mt-4 font-heading text-2xl md:text-3xl font-bold leading-tight">
                别让最新猛料 <br className="hidden sm:block" />
                从你眼皮底下溜走
              </h3>
              <p className="mt-3 text-sm text-background-50/75 leading-relaxed max-w-md">
                全站快讯滚动更新、猛料热榜实时刷新。把每日黑料加入追更清单，第一时间接收独家曝光与最新黑料。
              </p>
              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <a
                  href="#faq"
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 hover:bg-primary-400 transition-colors cursor-pointer"
                >
                  订阅每日黑料追更
                </a>
                <a
                  href="#lead"
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-50/25 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  先逛逛今日头版
                </a>
              </div>
              <p className="mt-4 text-xs text-background-50/50">
                * 当前为内容展示站，追更能力即将开放，敬请期待。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}